module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon6.d9eb36fd.png";